import { Delete } from "@mui/icons-material";
import { Button, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { Attachment, isAttachment, UnsavedAttachment } from "aint-types";
import { formatDate } from "aint-utils";

import { STRAPI_URL } from "../app/env";
import { EditInitiativeDialogFireEventType } from "../app/pages/edit-initiative-dialog/edit-initiative-dialog";

export function SupportingDocument({
  doc,
  documentIndex,
  fireEvent,
  readOnly = false,
}: {
  doc: UnsavedAttachment | Attachment;
  documentIndex: number;
  fireEvent?: EditInitiativeDialogFireEventType;
  readOnly?: boolean;
}) {
  const theme = useTheme();
  let name = "";
  let createdAt = "";
  let comment = "";
  if (isAttachment(doc)) {
    name = doc.name;
    createdAt = formatDate(doc.createdAt);
    comment = doc.caption;
  } else {
    name = doc.file.name;
    createdAt = formatDate(new Date());
    comment = doc.comment ?? "";
  }
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      marginTop="24px"
      color={theme.palette.grey[700]}
    >
      <Box
        display="flex"
        flexDirection="column"
        gap="8px"
        sx={{ cursor: isAttachment(doc) ? "pointer" : "initial" }}
        onClick={() => {
          if (isAttachment(doc)) {
            window.open(`${STRAPI_URL}${doc.url}`, "_blank");
          }
        }}
      >
        <Typography>
          {formatDate(createdAt)} |{" "}
          <span style={{ textDecoration: "underline" }}>{name}</span>
        </Typography>
        <Typography>{comment}</Typography>
      </Box>
      {!readOnly && (
        <Button sx={{ width: "32px", height: "32px" }}>
          <Delete
            sx={(theme) => ({
              cursor: "pointer",
              color: theme.palette.primary.contrastText,
              backgroundColor: "#ffffff",
              width: "25px",
              height: "25px",
              borderRadius: "6px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.primary.contrastText,
              },
            })}
            onClick={() => {
              const payload = isAttachment(doc)
                ? { fileId: doc.id }
                : { fileIndex: documentIndex };

              return fireEvent?.(
                "edit-dialog:delete-document-button-click",
                payload
              );
            }}
          />
        </Button>
      )}
    </Box>
  );
}
